module.exports = __webpack_public_path__ + "img/34800.7ebd8dcc.jpg";